import React, { useEffect,useState } from 'react';

const NumberFourTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,backToTopTabData }) => {
    const [isVisible, setIsVisible] = useState(false);
           
    const {
        is_website_frontend,
        text_title,
        button_color,
        icion_text_color,
        border_color,
        size_type,
        shape_type,
        position,
        scroll_position_to_display
    } = backToTopTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/back-to-top/temp-css/BackToTop.css`;
        if (widgetId) {
            link.setAttribute("back-to-top-data-dynamic-css", "back-to-top");
        } else {
            link.setAttribute("data-dynamic-css", "back-to-top");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="back-to-top"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    // Scroll Listener
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY >= Number(scroll_position_to_display)) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, [scroll_position_to_display]);

    // Scroll to Top Action
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <div className={`upgadeify back_to_top four-temp ${is_website_frontend}`}>
                {is_website_frontend !== "website-frontend" && (
                    <div className="back-to-top-content back-to-top-inner_image">
                        <img
                        src={`${process.env.PUBLIC_URL}/back-to-top/back-to-top-inner.png`}
                        alt="back-to-top-inner"
                        />
                    </div>
                )}
                {isVisible && (
                    <button className={`back_top_btn back_to_top_size back_top_btn_rounded ${position} ${size_type} ${shape_type}`} onClick={scrollToTop} style={{ background: button_color,borderColor: border_color }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="injected-svg"
                        >
                            <path fill={icion_text_color} d="m7.997 10 3.515-3.79a.672.672 0 0 1 .89-.076l.086.075L16 10l-3 .001V18h-2v-7.999L7.997 10z" />
                        </svg>
                        <span style={{ color: icion_text_color }}>{text_title}</span>
                    </button>
                )}
            </div>
        </>
    );
};

export default NumberFourTemplateWidget;
